/**
 * GA4 events для Google Ads / эффективности рекламы.
 * Measurement ID: G-GSGR5SCBP9 (GA4 property 548260420, avtosklo-kiev.com).
 * Google Ads tag: AW-18358097644 (customer 467-025-4431).
 */

export const GA_MEASUREMENT_ID = "G-GSGR5SCBP9";
export const AW_CONVERSION_ID = "AW-18358097644";

export type AnalyticsEventName =
  | "phone_click"
  | "whatsapp_click"
  | "telegram_click"
  | "viber_click"
  | "generate_lead"
  | "book_appointment"
  | "cta_click";

type EventParams = Record<string, string | number | boolean | undefined>;

export function trackEvent(name: AnalyticsEventName, params: EventParams = {}): void {
  if (typeof window === "undefined") return;
  const gtag = window.gtag;
  if (typeof gtag !== "function") return;

  gtag("event", name, {
    send_to: GA_MEASUREMENT_ID,
    ...params,
  });
}

export function trackPhoneClick(phone?: string): void {
  trackEvent("phone_click", {
    event_category: "contact",
    event_label: phone ?? "primary",
  });
}

export function trackMessengerClick(channel: "whatsapp" | "telegram" | "viber"): void {
  const map = {
    whatsapp: "whatsapp_click",
    telegram: "telegram_click",
    viber: "viber_click",
  } as const;
  trackEvent(map[channel], {
    event_category: "contact",
    event_label: channel,
  });
}

export function trackLead(source: string, extra: EventParams = {}): void {
  trackEvent("generate_lead", {
    event_category: "conversion",
    event_label: source,
    ...extra,
  });
}

export function trackCta(label: string): void {
  trackEvent("cta_click", {
    event_category: "engagement",
    event_label: label,
  });
}
